import { IInterval } from "../../../../Context/Interval";
import { ISystemContext } from "../../../../Context/SystemContext";
import { PixiSpriteResource } from "../../../../ResourceManager/PixiSpriteResource";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { CanvasSprite } from "../../../Sprite/CanvasSprite";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { Translator } from "../../../../Translator";
import { LogGroup, Scale, CreateElement, Size } from "../../../.././MyHelpers";
import { Slide, SlideFactory2Params } from "./Slide";
export class BigFreeGameBonusSlideDoubleSlide extends Slide {
	protected logGroup: LogGroup;
	protected resid: ResourceIdentifier;
	protected systemContext: ISystemContext;

    protected bonusInstruction: HTMLElement = null;
    protected bonusTitle: HTMLElement = null;
    protected bonusTrigger: HTMLElement = null;
    protected bonusTrigger2: HTMLElement = null;
    protected bonusInstruction2: HTMLElement = null;

    protected bonusDescription: HTMLElement = null;
    public override translator: Translator;

    //protected maxFreeGames: number = 0;
    protected SpriteFreegame: CanvasSprite = null;

    protected container: HTMLElement = null;


    //CREATE A CANVAS FOR WINCOUNT
    protected fontHeight: number =  Scale.fh(80);
    protected fontHeight2: number = Scale.fh(70);
    protected fontHeight3: number = Scale.fh(60);

    protected SripiteTimerLeft: IInterval;
    protected TitleSripiteTimer: IInterval;



    constructor(initData: SlotGameInitData, p: SlideFactory2Params , viewSize:Size) {
        super(initData, p , viewSize) ;
        this.viewSize = viewSize;
		this.logGroup = 	 this.p.logGroup.Add("FreeGameBonusSlideDoubleSlide");
		this.resid = 		 this.p.resid.Add("FreeGameBonusSlideDoubleSlide");
		this.systemContext = this.p.systemContext.CreateSubContext("FreeGameBonusSlideDoubleSlide");
        

        this.view = CreateElement("div", {
            classes: ["BigFreeGameSlide", this.resid.Scope()],
            style: {
                position: "absolute",
                height: viewSize.Height+"px",
                width: viewSize.Width+"px",
            }
        });
    }


    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        resourceManager.Add(new PixiSpriteResource(this.path + "Slider2/FGLeft", ResourceIdentifier.Global.Add(this.initData.GameName + "FGLeft").Add("FreegameTriggerSlider"), true, this.logGroup.Add("FreegameTriggerSlider"), true));

    }

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

        this.SpriteFreegame = new CanvasSprite({sprite: resourceManager.Get<PixiSpriteResource>(ResourceIdentifier.Global.Add(this.initData.Name + "FGLeft").Add("FreegameTriggerSlider")).sprite, canvasSize: new Size(this.viewSize.Width, this.viewSize.Height)});
        //this.SpriteFreegame.ScaleNonUniform(1.1, 1.2);
        this.SpriteFreegame.View().style.position = "relative";

        this.view.appendChild(this.SpriteFreegame.View());


        this.TitleSripiteTimer = this.systemContext.TimingContext().CreateInterval("BigFreeGameSlide", this.nextAnimInterval, () => this.SpriteFreegame.Start(false));
    }







	public override View(): HTMLElement
	{
        return this.view;
	}
	
	public override Update()
	{
        this.SpriteFreegame.Update();
	}
	
	public override Start()
	{
        this.TitleSripiteTimer.Start();
    }

	public override Stop()
	{
        this.TitleSripiteTimer.Stop();
        this.SpriteFreegame.StopAndReset();
    }
}
